const alerts = {
  normal: 0,
  warning: 1,
  critical: 2,
};

export default alerts;
